import React from 'react';
import { Link } from 'react-router-dom';
import { Watch, Clock, Mail } from 'lucide-react';

const PendingApprovalPage = () => {
  return (
    <div className="min-h-screen bg-[#fafafa] flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        <Link to="/" className="inline-flex items-center gap-2.5 mb-8">
          <div className="w-10 h-10 rounded-xl bg-[#0a0a0a] flex items-center justify-center">
            <Watch className="w-5 h-5 text-white" />
          </div>
          <span className="text-xl font-semibold text-[#0a0a0a] tracking-tight">Dial-Grid</span>
        </Link>
        <div className="bg-white rounded-2xl border border-[#e5e5e5] p-8 shadow-sm">
          <div className="w-14 h-14 rounded-full bg-amber-100 flex items-center justify-center mx-auto mb-4">
            <Clock className="w-7 h-7 text-amber-600" />
          </div>
          <h1 className="text-xl font-semibold text-[#0a0a0a] mb-2">Account pending approval</h1>
          <p className="text-[#737373] text-sm leading-relaxed mb-6">
            Thanks for signing up. Your account must be approved by an admin before you can sign in. We&apos;ll send you an email at the address you registered with once you&apos;re approved.
          </p>
          <p className="text-[#a3a3a3] text-xs flex items-center justify-center gap-1.5">
            <Mail className="w-4 h-4" />
            Check your inbox (and spam) for updates
          </p>
          <Link
            to="/login"
            className="mt-6 inline-block w-full py-3 rounded-lg bg-[#0a0a0a] text-white font-medium hover:bg-[#171717] transition-colors"
          >
            Back to sign in
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PendingApprovalPage;
